import { Image as ImageIcon, Minus, Plus } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

// Single product card on the employee browsing grid. Caller manages cart
// quantity & supplier resolution.
export default function ProductCard({ product, qty, supplier, onInc, onDec }) {
  const { t } = useLanguage();
  const selected = qty > 0;
  return (
    <div
      className={`bg-white rounded-xl border overflow-hidden transition-colors ${
        selected ? "border-[#0B1F3A]/40 ring-1 ring-[#0B1F3A]/10" : "border-[#E6E0D4] hover:border-[#0B1F3A]/25"
      }`}
    >
      <div className="aspect-[16/10] bg-[#F3EFE7] overflow-hidden">
        {product.image ? (
          <img
            src={product.image}
            alt=""
            loading="lazy"
            className="h-full w-full object-contain object-center"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-[#0B1F3A]/20">
            <ImageIcon size={24} />
          </div>
        )}
      </div>
      <div className="p-3">
        <p className="text-[14px] font-medium leading-snug line-clamp-2 min-h-[2.5em]">{product.name}</p>
        <p className="text-xs text-[#0B1F3A]/55 mt-1 truncate">
          {supplier?.name}{" "}
          <span className={supplier?.type === "delivered" ? "text-[#2B7A6B]" : "text-[#C4552B]"}>
            · {supplier?.type === "delivered" ? t("delivered") : t("direct")}
          </span>
        </p>
        <div className="mt-3 flex items-center justify-between">
          {qty === 0 ? (
            <button
              onClick={() => onInc(product.id)}
              className="h-9 px-3 rounded-full bg-[#F3EFE7] hover:bg-[#EAE3D2] text-[#0B1F3A] text-sm flex items-center gap-1.5 transition-colors"
            >
              <Plus size={14} /> {t("add")}
            </button>
          ) : (
            <div className="flex items-center gap-1 bg-[#F3EFE7] rounded-full p-1">
              <button onClick={() => onDec(product.id)} className="h-7 w-7 rounded-full bg-white border border-[#E6E0D4] flex items-center justify-center hover:border-[#0B1F3A]/40 transition-colors"><Minus size={14} /></button>
              <span className="min-w-7 text-center text-sm font-medium">{qty}</span>
              <button onClick={() => onInc(product.id)} className="h-7 w-7 rounded-full bg-[#0B1F3A] text-white flex items-center justify-center hover:bg-[#11294A] transition-colors"><Plus size={14} /></button>
            </div>
          )}
          <span className="text-[11px] text-[#0B1F3A]/50">{t("par")} {product.par} {product.unit}</span>
        </div>
      </div>
    </div>
  );
}
